import { render, staticRenderFns } from "./DirfBeneficiarios.vue?vue&type=template&id=fa869d98"
import script from "./DirfBeneficiarios.vue?vue&type=script&lang=js"
export * from "./DirfBeneficiarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports